<template>
	<template v-if="data && decisionStillValid">
		<TheForm :model="data" :rules="rules" ref="formRef" :waiting="waiting" :id="formId" v-if="data.decisionType !== DecisionType.SmallSenate">
			<section>
				<ButtonSticky @buttonclick="saveDecision()" isSubmit>
					<template v-slot:icon><saveIcon /></template>
					<template v-slot:text> Speichern </template>
				</ButtonSticky>

				<ButtonBack />

				<h1>Entscheidung: {{ data.case.title }}</h1>

				<h2>Entscheidung</h2>

				<TheBox>
					<el-form-item label="" prop="decisionState">
						<el-radio-group v-model="data.decisionState">
							<el-radio v-for="item in decisionOptions" :key="item" :value="item" :border="true">
								{{ $getStateFullLabel('decision', item, false).replace('Entscheidung: ', '') }}
							</el-radio>
						</el-radio-group>
					</el-form-item>

					<div class="flex flex--aligncenter">
						<span>Diese Entscheidung mit Werberät:innen teilen</span>
						<TheToggle :active="data.shared" @toggle="data.shared = !data.shared" />
					</div>

					<p id="ethikkodex-wrapper">
						Sie wollen vor Ihrer Entscheidung nochmal den Ethik-Kodex durchsehen?
						<a
							href="https://www.werberat.at/ethik-kodex-der-%C3%B6sterreichischen-werbewirtschaft"
							target="_blank"
							title="Ethik-Kodex anzeigen"
							class="link"
						>
							Ethik-Kodex anzeigen
						</a>
					</p>
				</TheBox>
			</section>

			<section v-if="data.categories.length > 0 && !disabledCategories">
				<TheBox :title="'Bereits gewählte Kategorien'">
					<DetailsUserDecision
						:decisionCategories="data.categories"
						:decisionState="data.decisionState"
						:isInEditMode="true"
						@update:selectedCategories="(cats) => (previouslySelectedCategories = cats)"
					/>
				</TheBox>
			</section>

			<section v-for="(panel, panelIndex) in selectionPanels" :key="panel.id" class="category-checkboxes">
				<TheBox>
					<el-row v-for="(selection, selectionIndex) in panel.selections" :key="selectionIndex">
						<el-select
							v-model="selection.selectedCategoryId"
							placeholder="Kategorie auswählen"
							@change="updateSelection(panelIndex, selectionIndex, $event)"
						>
							<el-option v-for="option in selection.options" :key="option.id" :label="`${option.number} ${option.name}`" :value="option.id" />
						</el-select>
					</el-row>

					<el-checkbox-group v-model="panel.finalSelections" v-if="panel.finalOptions.length > 0">
						<div v-for="category in panel.finalOptions" :key="category.id" class="checkbox-container">
							<div class="category-checkbox" v-if="!category.isParent">
								<el-checkbox :value="category.id" @change="toggleFinalSelection(panelIndex, category)">
									{{ category.number }} {{ category.name }}
								</el-checkbox>
							</div>

							<div v-else class="parent-label">{{ category.number }} {{ category.name }}</div>
						</div>
					</el-checkbox-group>

					<TheButton @click="removePanel(panelIndex)" type="" text>Kategorie entfernen</TheButton>
				</TheBox>
			</section>

			<section @click="addSelectionPanel" id="box--addcategory" :class="disabledCategories ? 'box--addcategory--disabled' : ''">
				<TheBox>
					<div class="box__header">
						<h3> {{ selectionPanels.length > 0 ? 'Weitere' : '' }} Ethik-Kategorie auswählen </h3>
						<el-icon><CirclePlusFilled /></el-icon>
					</div>
				</TheBox>

				<div v-if="showCategoryError" class="el-form-item__error">{{ texts.formErrors.decisionCategoryMissing }}</div>
			</section>

			<section>
				<TheBox :title="'Begründung'">
					<el-form-item label="" prop="reasonText">
						<el-input v-model="data.reasonText" :autosize="{ minRows: 3 }" type="textarea" placeholder="Begründen Sie hier Ihre Entscheidung..." />
					</el-form-item>
				</TheBox>
			</section>
		</TheForm>
		<TheForm :model="data" :rules="rules" ref="formRef" :waiting="waiting" :id="formId" v-if="data.decisionType === DecisionType.SmallSenate">
			<section>
				<ButtonSticky @buttonclick="saveDecision()" isSubmit>
					<template v-slot:icon><saveIcon /></template>
					<template v-slot:text> Speichern </template>
				</ButtonSticky>

				<ButtonBack />

				<h1>Entscheidung: {{ data.case.title }}</h1>

				<h2>Senatsentscheidung</h2>

				<TheBox>
					<el-form-item label="" prop="decisionState">
						<el-radio-group v-model="data.decisionState" class="decision-buttons">
							<el-radio v-for="item in senateDecisionOptions" :key="item" :value="item" :border="true" class="decision-button">
								{{
									item === DecisionState.StopSmallSenate
										? 'Als unbegründet abweisen'
										: $getStateFullLabel('decision', item, false).replace('Entscheidung: ', '')
								}}
							</el-radio>
						</el-radio-group>
					</el-form-item>

					<div class="flex">
						<span>Diese Entscheidung wird automatisch mit anderen Senator:innen geteilt</span>
					</div>
				</TheBox>
			</section>

			<section>
				<TheBox :title="'Begründung'">
					<el-form-item label="" prop="reasonText">
						<el-input v-model="data.reasonText" :autosize="{ minRows: 3 }" type="textarea" placeholder="Begründen Sie hier Ihre Entscheidung..." />
					</el-form-item>
				</TheBox>
			</section>
		</TheForm>

		<section>
			<h2>Fall</h2>

			<CasesTable :tableData="[data.case]" :totalCount="1" @loadNextPage="null" :mobileBox="true" />
		</section>

		<DialogLeavePage v-model:open="openClosingDialog" @cancel="leavePage" @save="saveDecision(true)" />
	</template>

	<section v-else-if="data && !decisionStillValid">
		<ButtonBack />
		<h1>Entscheidungsfrist abgelaufen</h1>
		<p>Leider ist die Frist für Ihre Entscheidung bereits abgelaufen.</p>
	</section>

	<section v-else-if="loading === false">
		<ButtonBack />
		<el-alert :title="texts.general.emptyText" type="error" effect="dark" :closable="false" />
	</section>
</template>

<script lang="ts">
import CasesTable from '@/components/tables/CasesTable.vue';
import { getDecision, putDecision } from '@/requests/decisions';
import { Delete, Plus, Loading, CirclePlusFilled } from '@element-plus/icons-vue';
import DetailsUserDecision from '@/views/sections/DetailsUserDecision.vue';
import DialogLeavePage from '../components/dialogs/DialogLeavePage.vue';
import { defineComponent, ref, markRaw } from 'vue';
import saveIcon from '../assets/icons/saveIcon.vue';
import ButtonBack from '../components/buttons/ButtonBack.vue';
import ButtonSticky from '../components/buttons/ButtonSticky.vue';
import TheBox from '../components/TheBox.vue';
import TheButton from '../components/TheButton.vue';
import TheForm from '../components/TheForm.vue';
import TheToggle from '../components/TheToggle.vue';
import { CaseState, CategoryDto, DecisionResponse, DecisionState, DecisionType, PutDecisionRequest } from '../types/types';
import { texts } from '../utils/texts';
import { categories } from '@/utils/categories';
import { returnFormOptions } from '@/utils/formOptions';
import { startLoading, stopLoading } from '@/utils/loading/loadingHandler';
import type { FormInstance } from 'element-plus';
import { ElMessage } from 'element-plus';
import { validateForm, hasArrayChanged, hasFormChanged } from '../utils/functions';
import type { RouteLocationRaw } from 'vue-router';
import cloneDeep from 'lodash/cloneDeep';

const ElMessageDuration = 1500;

export default defineComponent({
	name: 'EntscheidungEdit',
	data() {
		return {
			data: null as DecisionResponse | null,
			initialData: null as DecisionResponse | null,
			formId: 'decisionForm',
			waiting: false,
			rules: {
				decisionState: [{ required: true, message: texts.formErrors.decisionMissing, trigger: ['blur', 'change'] }],
			},
			saveDecisionRequest: null as PutDecisionRequest | null,
			loading: true,
			categories,
			decisionOptions: [DecisionState.NoReason, DecisionState.Awareness, DecisionState.Stop, DecisionState.Biased],
			senateDecisionOptions: [DecisionState.StopSmallSenate, DecisionState.GoSmallSenate],

			currentlySelectedCategories: [] as CategoryDto[],
			selectionPanels: [] as any[],
			DecisionState,
			CaseState,
			openClosingDialog: false,
			checkPageLeave: true,
			pageLeaveTo: null as RouteLocationRaw | null,
			DecisionType,
			previouslySelectedCategories: [] as any[],
			showCategoryError: false,

			finalSelectionsRequest: [] as any[],
		};
	},
	props: {
		id: {
			type: String,
			required: true,
		},
	},
	components: {
		ButtonBack,
		ButtonSticky,
		TheButton,
		TheForm,
		TheBox,
		TheToggle,
		CasesTable,
		Plus,
		Delete,
		Loading,
		saveIcon,
		CirclePlusFilled,
		DialogLeavePage,
		DetailsUserDecision,
	},
	setup() {
		const formRef = ref<FormInstance | null>(null);

		return {
			formRef,
		};
	},
	computed: {
		texts() {
			return texts;
		},
		categoryOptions() {
			return returnFormOptions('decisionCategories');
		},
		smallSenateDecisionOptions() {
			return returnFormOptions('smallSenateDecisionStateOptions');
		},
		decisionStillValid() {
			if (!this.data) return false;
			if (this.data.decisionType === DecisionType.SmallSenate) {
				return this.data.case.state === CaseState.ExaminationSmallSenate || this.data.case.state === CaseState.ExaminationSmallSenateRunning;
			} else if (this.data.decisionType === DecisionType.Werberat || this.data.decisionType === DecisionType.JungerWerberat) {
				return this.data.case.state === CaseState.ExaminationWerberat || this.data.case.state === CaseState.ExaminationWerberatRunning;
			}
			return false;
		},
		disabledCategories() {
			if (!this.data) return false;
			return this.data.decisionState === DecisionState.Biased || this.data.decisionState === DecisionState.NoReason;
		},
	},
	methods: {
		async saveDecision(leavePage = false) {
			if (!this.data) return;

			const isValid = await validateForm(this.formRef, this.formId);

			if (!isValid) return;

			this.finalSelectionsRequest = this.getFinalSelectionsRequest();

			// category is required if decision is not Biased or NoReason
			if (this.data.decisionType !== DecisionType.SmallSenate && this.finalSelectionsRequest.length === 0 && !this.disabledCategories) {
				this.showCategoryError = true;
				return;
			}

			this.waiting = true;
			const waitingMsg = ElMessage({ message: texts.formErrors.waiting, type: 'info', duration: 0, showClose: false, icon: markRaw(Loading) });

			this.saveDecisionRequest = {
				decisionState: this.data.decisionState,
				id: this.id,
				reasonText: this.data.reasonText,
				shared: this.data.decisionType !== DecisionType.SmallSenate ? this.data.shared : true,
				categories: this.data.decisionType !== DecisionType.SmallSenate && !this.disabledCategories ? this.finalSelectionsRequest : [],
			};

			const saveDecisionResult = await putDecision(this.saveDecisionRequest);
			if (saveDecisionResult.success) {
				if (leavePage) this.leavePage();
				else {
					this.checkPageLeave = false;
					this.$router.push({ name: 'EntscheidungDetail', params: { id: String(this.id) }, replace: true });
				}
			} else {
				ElMessage({ message: texts.decisions.saveFailed, type: 'error', duration: ElMessageDuration });
			}

			this.waiting = false;
			waitingMsg.close();
		},
		getFinalSelectionsRequest() {
			let finalSelections = this.selectionPanels
				.map((p) =>
					p.finalSelections
						.filter((s) => s.id)
						.map((s) => {
							return { number: s.number };
						}),
				)
				.flat();

			this.previouslySelectedCategories.forEach((c) => {
				if (!this.finalSelectionsRequest.find((s) => s.number === c.number)) {
					finalSelections.push({ number: c.number });
				}
			});

			return finalSelections;
		},
		async loadDecision() {
			const loading = startLoading('#entscheidung');

			const result = await getDecision(this.id);
			if (result.success) {
				this.data = result.data;
				this.previouslySelectedCategories = result.data.categories;

				this.initialData = cloneDeep(result.data);
			}

			this.loading = false;
			stopLoading(loading);
		},
		addSelectionPanel() {
			this.showCategoryError = false;

			// cannot set categories if decisionState is Biased or NoReason
			if (this.disabledCategories) return;

			this.selectionPanels.push({
				id: Date.now(),
				selections: [
					{
						level: 0,
						selectedCategoryId: null,
						options: this.categories.filter((c) => c.isFromCodeOfEthics),
					},
				],
				finalOptions: [],
				finalSelections: [],
			});
		},
		updateSelection(panelIndex, levelIndex, categoryId) {
			const panel = this.selectionPanels[panelIndex];
			const selection = panel.selections[levelIndex];
			const category = selection.options.find((c) => c.id === categoryId);
			selection.selectedCategoryId = categoryId;

			panel.selections.splice(levelIndex + 1);
			panel.finalOptions = [];
			panel.finalSelections = [];
			if (category.children?.length > 0) {
				const oneChildHasNoChildren = category.children.some((child) => !child.children || child.children.length === 0);
				if (!oneChildHasNoChildren) {
					panel.selections.push({
						level: levelIndex + 1,
						selectedCategoryId: null,
						options: category.children,
					});
				} else {
					let childlist = [] as any[];
					category.children.forEach((child) => {
						if (child.children) {
							child = { ...child, isParent: true };
						}
						childlist.push(child);
						if (child.children) {
							childlist = childlist.concat(child.children);
						}
					});
					panel.finalOptions = childlist;
				}
			} else {
				panel.finalOptions = [category];
			}
		},
		toggleFinalSelection(panelIndex, category) {
			const panel = this.selectionPanels[panelIndex];
			const index = panel.finalSelections.findIndex((c) => c.id === category.id);

			if (index !== -1) {
				panel.finalSelections.splice(index, 1);
			} else {
				panel.finalSelections.push(category);
			}
		},
		removePanel(panelIndex) {
			this.selectionPanels.splice(panelIndex, 1);
		},
		leavePage() {
			this.openClosingDialog = false;
			this.checkPageLeave = false;

			// @ts-ignore
			this.$router.push(this.pageLeaveTo);
		},
	},
	beforeRouteLeave(to, from, next) {
		if (this.checkPageLeave === false) {
			next();
			return;
		}

		// if values dont exist: data could not be loaded
		if (!this.initialData || !this.data) {
			next();
			return;
		}

		// check if data has changed
		const hasChanged = hasFormChanged({ initialData: this.initialData, currentData: this.data });

		let finalSelectionsRequest = this.getFinalSelectionsRequest();
		let oldCategoryNumbers = this.initialData?.categories.map((c) => {
			return { number: c.number };
		});

		if (!hasChanged && this.initialData.decisionState === this.data.decisionState && !hasArrayChanged(oldCategoryNumbers, finalSelectionsRequest)) {
			next();
			return;
		}

		this.openClosingDialog = true;
		this.pageLeaveTo = to;
		next(false);
	},
	mounted() {
		this.loadDecision();
	},
});
</script>

<style lang="scss">
@use '../scss/vars.scss' as *;
#entscheidung-bearbeiten {
	.el-select {
		margin-bottom: 0.8rem;
	}

	.parent-label {
		font-weight: bold;
		margin: 1rem 0;
		font-size: 0.9rem;
		line-height: 2rem;
	}

	section:first-of-type {
		margin-top: 0;
	}

	#box--addcategory {
		cursor: pointer;

		.el-form-item__error {
			margin-top: 1rem;
		}

		&.box--addcategory--disabled {
			cursor: not-allowed;

			.box .box__header {
				.el-icon svg,
				h3 {
					color: var(--el-color-lightgrey-2);
				}
			}
		}

		.box__header {
			margin-bottom: 0;
		}
	}

	.toggle {
		margin-left: 1rem;
	}

	#ethikkodex-wrapper {
		margin: 0;
		margin-top: 0.5rem;
		a {
			margin: 0;
		}
	}

	.el-radio-group {
		width: 100%;
		display: flex;
		justify-content: space-between;
		margin-bottom: 0.5rem;

		.el-radio.is-bordered {
			width: calc(25% - 0.75rem);
			margin: 0;
			border-radius: 7px;
			border-color: var(--el-color-primary);
			height: auto;

			&.is-checked {
				background-color: var(--el-color-green);
				border-color: var(--el-color-green);
			}
		}

		.el-radio__input {
			display: none;
		}

		.el-radio__label {
			width: 100%;
			text-align: center;
			padding: 0.3rem !important;
			display: inline-block;
		}
	}
}

/* mobile styles */
@media screen and (max-width: $mobile_maxwidth) {
	#entscheidung-bearbeiten {
		.el-radio-group {
			flex-direction: column;
			.el-radio.is-bordered {
				width: 100%;
				margin-bottom: 0.75rem;
			}
		}
	}
}
</style>
